import { render, staticRenderFns } from "./BirthdayPicker.vue?vue&type=template&id=63a71f32&scoped=true&lang=pug"
import script from "./BirthdayPicker.vue?vue&type=script&lang=js"
export * from "./BirthdayPicker.vue?vue&type=script&lang=js"
import style0 from "./BirthdayPicker.vue?vue&type=style&index=0&id=63a71f32&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a71f32",
  null
  
)

export default component.exports